// Time controls (GDD §3.1): Step (manual advance) and Blitz (1 game year =
// 60 s) surfaced in M2; Fast/Live exist as clock constants, untested until M9.

import { MS_PER_GAME_YEAR, type Clock } from '../game/clock.ts';

export function TimeControls({
  clock,
  alive,
  onRunBlitz,
  onPause,
  onStep,
}: {
  clock: Clock;
  alive: boolean;
  onRunBlitz: () => void;
  onPause: () => void;
  onStep: (years: number) => void;
}) {
  const running = clock.running && alive;
  const blitzSecs = MS_PER_GAME_YEAR.blitz! / 1000;
  return (
    <div className="time-controls" aria-label="Time controls">
      <span className={`mode-badge ${running ? 'running' : ''}`}>
        {running ? `Blitz · 1 year = ${blitzSecs}s` : 'Step · paused'}
      </span>
      {running ? (
        <button onClick={onPause}>⏸ Pause</button>
      ) : (
        <>
          <button onClick={onRunBlitz} disabled={!alive}>
            ▶ Blitz
          </button>
          <button onClick={() => onStep(1 / 12)} disabled={!alive}>
            +1 month
          </button>
          <button onClick={() => onStep(1)} disabled={!alive}>
            +1 year
          </button>
        </>
      )}
    </div>
  );
}
